import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthorizeGuard } from 'src/app/core/guards/authorize.guard';
import { CampaignDetailsComponent } from './add-special-offer/campaign-details/campaign-details.component';
import { FinancingDetailsComponent } from './add-special-offer/financing-details/financing-details.component';
import { CampaignDescriptionComponent } from './add-special-offer/campaign-description/campaign-description.component';
import { ClientSegmentationComponent } from './add-special-offer/client-segmentation/client-segmentation.component';
import { CampaignPublishedComponent } from './add-special-offer/campaign-published/campaign-published.component';
import { PreviewComponent } from './special-offer-detail/preview/preview.component';
import { SpecialOfferListComponent } from './special-offer-list/special-offer-list.component';
import { SpecialOfferDeactivateGuard } from 'src/app/core/guards/special-offer.guard';
import { RightsGuard } from 'src/app/core/guards/rights.guard';
import { SPECIAL_OFFER_ROUTES } from 'src/app/core/constants/routes-constants';

const routes: Routes = [
  {
    path: SPECIAL_OFFER_ROUTES.ADMIN_SPECIAL_OFFERS,
    canActivate: [AuthorizeGuard, RightsGuard],
    children: [
      { path: '', component: SpecialOfferListComponent },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.CAMPAIGN_DETAILS}`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: CampaignDetailsComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.CAMPAIGN_DETAILS}/:specialOfferId`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: CampaignDetailsComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.FINANCING_DETAILS}`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: FinancingDetailsComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.FINANCING_DETAILS}/:specialOfferId`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: FinancingDetailsComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.CAMPAIGN_DESCRIPTION}`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: CampaignDescriptionComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.CAMPAIGN_DESCRIPTION}/:specialOfferId`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: CampaignDescriptionComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.CLIENT_SEGMANTATION}`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: ClientSegmentationComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.CLIENT_SEGMANTATION}/:specialOfferId`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: ClientSegmentationComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.CAMPAIGN_PUBLISHED}`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: CampaignPublishedComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.PREVIEW}`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: PreviewComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.NEW}/${SPECIAL_OFFER_ROUTES.PREVIEW}/:specialOfferId`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: PreviewComponent,
      },
      {
        path: `${SPECIAL_OFFER_ROUTES.PREVIEW}/:specialOfferId`,
        canDeactivate: [SpecialOfferDeactivateGuard],
        component: PreviewComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class SpecialOfferAdminRoutingModule {}
